import DropDown from '@/trio-ui/Dropdown';
import { ValuesWithLabel } from '@/types';
import * as Styles from './ChallengeTypeInput.styles';
import TechnologiesDropdown from '../TechnologiesDropdown';

export type ChallengeTypeInputComponentProps = {
  options: ValuesWithLabel[];
  value: string;
  onChangeDropDown: (event: any) => void;
  isDisabled?: boolean;
  languageUsedByCandidate: string[];
  onChangeLanguageUsed: (event: any) => void;
};

export default function ChallengeTypeInputComponent({
  options,
  value,
  onChangeDropDown,
  isDisabled,
  languageUsedByCandidate,
  onChangeLanguageUsed,
}: ChallengeTypeInputComponentProps): JSX.Element {
  return (
    <Styles.Container>
      <div className="tw-flex tw-gap-4 tw-w-full">
        <div className="tw-w-full">
          <DropDown
            isLabelAboveField
            isDisabled={isDisabled}
            name="challenge-type-input"
            label="Technical Challenge"
            options={options}
            defaultValue={value}
            onChangeDropDown={onChangeDropDown}
          />
        </div>
        <div className="tw-w-full">
          <TechnologiesDropdown
            label="Used Language"
            name="language-used"
            defaultValue={languageUsedByCandidate}
            onChange={onChangeLanguageUsed}
            isActiveOnly
          />
        </div>
      </div>
    </Styles.Container>
  );
}
